module.exports = __webpack_public_path__ + "img/yq.c1eed9f6.png";